import { render, staticRenderFns } from "./dateselectionheader.vue?vue&type=template&id=45416fb3&scoped=true&"
import script from "./dateselectionheader.vue?vue&type=script&lang=js&"
export * from "./dateselectionheader.vue?vue&type=script&lang=js&"
import style0 from "./dateselectionheader.vue?vue&type=style&index=0&id=45416fb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45416fb3",
  null
  
)

export default component.exports